class Document {
  constructor(model) {
    this.file = model.file;
    this.name = model.file.split('/')[model.file.split('/').length - 1];
    this.file_type = model.file_type;
    this.id = model.id;
    this.parcel_id = model.parcel_id;
    this.tag = model.tag;
    this.title = model.title;
    this.upload_date = model.upload_date;
    this.year = model.year
  }

  static formatPost(state) {
    let formData = new FormData();
    state.files.map(file => {
      formData.append('files', file);
    })
    formData.append('title', state.title);
    formData.append('tag', state.tag);
    formData.append('year', state.year);
    formData.append('parcel_id', state.parcel);

    return formData;
  }
}

export default Document;